<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="transfers" [hidden]="spinner">
  <header class="transfers--header">
    <div class="transfers--header__container">
      <h5 class="transfers--header__title">
        {{ 'transfersRequest' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestTypeEnum.transfers"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
